@if (page.content.length !== 0) {
<nav aria-label="Page navigation">
  <ul class="pagination pt-4">
    @if (!first) {
    <li class="page-item">
      <a class="page-link" (click)="setCurrentPage(page.previous())" title="page backward">
        <span class="material-symbols-outlined">first_page</span>
      </a>
    </li>
    } @for (index of range; track index) { @if (index === '...') {
    <li class="page-item disabled">
      <span class="page-link ellipsis">…</span>
    </li>
    } @else {
    <li class="page-item">
      <a
        class="page-link"
        [ngClass]="{ 'current-page': index === page.number }"
        (click)="setCurrentPage(page.at(index))"
        >{{ index }}</a
      >
    </li>
    } } @if (!last) {
    <li class="page-item">
      <a class="page-link" (click)="setCurrentPage(page.next())" title="page forward">
        <span class="material-symbols-outlined">last_page</span>
      </a>
    </li>
    }
  </ul>
</nav>
}
